import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import { DeleteIcon } from "../gui_components/Icons.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupARModule,
  PopupCreditMemoModule,
  PopupInvoiceModule,
  PopupPickTicketModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js";

import {
  CustomerSearchCriteria,
  CustomerServiceInquiryCriteria,
  CustomerServicePrintRequest,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
  SalesPersonBean,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  ColumnDefinition,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { ModuleUtils } from "../modules/ModuleUtils";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class CustomerServiceInq extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Customer Service Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      cities: [],
      inquiryDataList: [],
      summaryData: [],
      salesPersons: [],
      customerList: new Array(),
      salesPersonBean: new SalesPersonBean(),
      criteria: new CustomerServiceInquiryCriteria(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowSalesModule: false,
      moduleForPopup: [],
      isCollapsible_open: true,
      customerData: null,
      spData: null,
      customerDatas: [],
      salesPersonDatas: [],
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      salesPersonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonCodeList: true,
      salesPersonCodePageListForAutoCompleteList: new Array(),
      isDisableFields: false,
      pickTicketDataList: [],
      isShowInvoiceModule: false,
      isShowPickTicketModule: false,
      readARAppliedList: [],
      isShowArPopup: false,
      isShowARModule: false,
      isShowCreditMemoPopup: false,
      isShowCreditMemoModule: false,
      readCMAppliedList: [],
      order: "asc",
      sortField: "",
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let salesPersons = attribute_cache.salesPersons;
    if (salesPersons != null || salesPersons != undefined) {
      salesPersons.map((attr) => {
        this.state.salesPersons.push(attr);
      });
    }
    let cities = attribute_cache.cities;
    if (cities != null || cities != undefined) {
      cities.map((attr) => {
        this.state.cities.push(attr);
      });
    }
    let criteria = this.state.criteria;
    const currentDay = new Date();
    const firstDay = new Date(currentDay.getFullYear(), 0, 1);
    criteria.fromOrderDate = firstDay;
    criteria.toOrderDate = currentDay;
    this.setState({ criteria, criteria });

    ModuleUtils.getSalesOrderStatusList();
    ModuleUtils.getPickTicketStatusList();
    ModuleUtils.getInvoiceStatusList();
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onCityChange = (e) => {
    let cityCode = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(cityCode)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_criteria = this.state.criteria;
      temp_criteria.cityCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: temp_criteria,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && cityCode !== "") {
      this.readcityBySearchString(cityCode);
    }
    if (e.target.name == "cityCode") {
      temp_criteria["cityCode"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_criteria["cityCode"] = city.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ criteria: temp_criteria });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEvent = (e) => {
    let temp_criteria = this.state.criteria;
    let cityCode = e.target.value;
    temp_criteria["cityCode"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.cityCode = cityBean.code;
      this.setState({
        criteria: temp_criteria,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  salesPersonCodeOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      let criteria = this.state.criteria;
      criteria.salesPersonCode = "";
      criteria.salesPersonName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonBySearchString(salesPersonCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  salesPersonOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonCodeList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonCodeList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonCodeList;
      let criteria = this.state.criteria;
      criteria.salesPersonCode = "";
      criteria.salesPersonName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteSalesPersonCodeList: showAutoCompleteList,
        criteria: criteria,
        salesPersonCodePageListForAutoCompleteList: suggestion,
        salesPersonBean: null,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonCodeBySearchString(salesPersonCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readSalesPersonCode = (salesPersonCode) => {
    let salesPersonBean = null;
    this.state.salesPersons.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.salesPersonCode = salesPersonBean.code;
      this.state.showAutoCompleteSalesPersonCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonCodeList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteSalesPersonCodeList: showAutoCompleteList,
      });
    }
    this.setState({ salesPersonBean: salesPersonBean });
  };
  readSalesPerson = (salesPersonCode) => {
    let salesPersonBean = null;
    this.state.salesPersons.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.salesPersonCode = salesPersonBean.code;
      temp_criteria.salesPersonName = salesPersonBean.description;
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ salesPersonBean: salesPersonBean });
  };

  readSalesPersonBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersons;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readSalesPersonCodeBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersons;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonCodePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  salesPersonEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPerson(salesPersonCode);
    this.setState({
      salesPersonPageListForAutoCompleteList: new Array(),
    });
  };
  salesPersonCodeEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPersonCode(salesPersonCode);
    this.setState({
      salesPersonCodePageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesPersonCodeList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteSalesPersonCodeList: showAutoCompleteList,
    });
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
  };

  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    CustomerService.readCustomer(
      readrestInput,
      this.editCustomerResponse,
      this.errorCallBack
    );
  };
  editCustomerResponse = (response) => {
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      let criteria = this.state.criteria;
      criteria.customerCode = customerData.code;
      criteria.customerName = customerData.description;
      this.setState({ customerData: customerData, criteria: criteria });
    }
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    if (response.data != null && response.data.customerPageList != null) {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomer(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadCustomerServiceInquiryList(criteria);
  };
  loadCustomerServiceInquiryList = (criteria) => {
    if (SecurityAccessManager.CustomerServiceInquiry_IsAccessible()) {
      ReportService.inquireCustomerServiceReport(
        criteria,
        this.loadCustomerServicePageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCustomerServicePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let invoiceInfoDataList = [];
      if (!isEmptyArray(response.data.result.reportInfos)) {
        invoiceInfoDataList = response.data.result.reportInfos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: invoiceInfoDataList,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new CustomerServiceInquiryCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.customerName = "";
    tempCriteria.salesPersonName = "";
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1
    );
    tempCriteria.fromOrderDate = firstDay;
    tempCriteria.toOrderDate = currentDay;
    this.setState({
      criteria: tempCriteria,
      salesPersonDatas: [],
      salesPersonBean: new SalesPersonBean(),
      isDisableFields: false,
    });
  };
  resetInquiry = () => {
    let tempCriteria = new CustomerServiceInquiryCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.customerName = "";
    tempCriteria.salesPersonName = "";
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1
    );
    tempCriteria.fromOrderDate = firstDay;
    tempCriteria.toOrderDate = currentDay;
    this.setState({
      criteria: tempCriteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      salesPersonBean: new SalesPersonBean(),
      salesPersonDatas: [],
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isCollapsible_open: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CustomerServicePrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.CustomerServiceInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateCustomerServicePrintReport(
          listRequest,
          this.generateCustomerServicePageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CustomerServiceInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateCustomerServicePrintReport(
          listRequest,
          this.generateCustomerServicePageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCustomerServicePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateCustomerServicePageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
         let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        if (!isEmptyString(reportFilePath)) {
          window.open(downloadAddress, "_blank");
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  addSalesPerson = () => {
    let criteria = this.state.criteria;
    criteria.salesPersonCode = "";
    criteria.salesPersonName = "";
    let salesPersonBean = this.state.salesPersonBean;
    let salesPersonDatas = this.state.salesPersonDatas;
    if (salesPersonBean != null) {
      if (!isEmptyArray(salesPersonDatas)) {
        let exists = salesPersonDatas.find(
          (p) => p.code === salesPersonBean.code
        );
        if (!exists) {
          salesPersonDatas.push(salesPersonBean);
          criteria.salesPersonCodes.push(salesPersonBean.code);
          this.setState({
            criteria: criteria,
            salesPersonDatas: salesPersonDatas,
            salesPersonBean: null,
          });
        }
      } else {
        if (!isEmptyString(salesPersonBean.code)) {
          salesPersonDatas.push(salesPersonBean);
          criteria.salesPersonCodes.push(salesPersonBean.code);
          this.setState({
            criteria: criteria,
            salesPersonDatas: salesPersonDatas,
            salesPersonBean: null,
          });
        }
      }
    }
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  deleteSalesPerson = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.salesPersonCodes;
    let salesPersonDatas = this.state.salesPersonDatas;
    salesPersonDatas.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        salesPersonDatas.splice(index, 1);
      }
    });
    this.setState({ criteria: criteria, salesPersonBean: null });
  };

  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  pickticket = (value) => {
    let pickTicket = null;
    if (!isEmptyArray(value)) {
      value.map((line) => {
        pickTicket = line.pickTicketNumber;
      });
    }
    return pickTicket;
  };
  date = (value) => {
    let date = null;
    if (!isEmptyArray(value)) {
      value.map((line) => {
        date = line.pickTicketDate;
      });
    }
    return date;
  };
  status = (value) => {
    let status = null;
    if (!isEmptyArray(value)) {
      value.map((line) => {
        let lineStatus = line.status;
        status = ModuleUtils.getPickTicketStatusCaption(lineStatus);
      });
    }
    return status;
  };
  invoice = (value) => {
    let invoice = null;
    if (!isEmptyArray(value)) {
      value.map((line) => {
        let invoiceList = [];
        invoiceList = line.invoiceInfos;
        if (!isEmptyArray(invoiceList)) {
          invoiceList.map((line) => {
            invoice = line.invoiceNumber;
          });
        }
      });
    }
    return invoice;
  };
  invoiceDate = (value) => {
    let date = null;
    if (!isEmptyArray(value)) {
      value.map((line) => {
        let invoiceList = [];
        invoiceList = line.invoiceInfos;
        if (!isEmptyArray(invoiceList)) {
          invoiceList.map((line) => {
            date = line.invoiceDate;
          });
        }
      });
    }
    return date;
  };
  amount = (value) => {
    let amount = null;
    if (!isEmptyArray(value)) {
      value.map((line) => {
        let invoiceList = [];
        invoiceList = line.invoiceInfos;
        if (!isEmptyArray(invoiceList)) {
          invoiceList.map((line) => {
           // amount = line.invoiceAmount;
            amount = toCommaSeperatedAmount(line.invoiceAmount)
          });
        }
      });
    }
    return amount;
  };
  invoiceStatus = (value) => {
    let status = null;
    if (!isEmptyArray(value)) {
      value.map((line) => {
        let invoiceList = [];
        invoiceList = line.invoiceInfos;
        if (!isEmptyArray(invoiceList)) {
          invoiceList.map((line) => {
            let lineStatus = line.status;
            status = ModuleUtils.getInvoiceStatusCaption(lineStatus);
          });
        }
      });
    }
    return status;
  };
  totalCreditAmount = (value) => {
    let totalCreditAmount = null;
    if (!isEmptyArray(value)) {
      value.map((line) => {
        let invoiceList = [];
        invoiceList = line.invoiceInfos;
        if (!isEmptyArray(invoiceList)) {
          invoiceList.map((line) => {
           // totalCreditAmount = line.totalCreditAmount;
           totalCreditAmount = toCommaSeperatedAmount(line.totalCreditAmount)
          });
        }
      });
    }
    return totalCreditAmount;
  };
  totalDueAmount = (value) => {
    let totalDueAmount = null;
    if (!isEmptyArray(value)) {
      value.map((line) => {
        let invoiceList = [];
        invoiceList = line.invoiceInfos;
        if (!isEmptyArray(invoiceList)) {
          invoiceList.map((line) => {
           // totalDueAmount = line.totalDueAmount;
           totalDueAmount = toCommaSeperatedAmount(line.totalDueAmount)
          });
        }
      });
    }
    return totalDueAmount;
  };
  totalPaidAmount = (value) => {
    let totalPaidAmount = null;
    if (!isEmptyArray(value)) {
      value.map((line) => {
        let invoiceList = [];
        invoiceList = line.invoiceInfos;
        if (!isEmptyArray(invoiceList)) {
          invoiceList.map((line) => {
        //    totalPaidAmount = line.totalPaidAmount;
        totalPaidAmount = toCommaSeperatedAmount(line.totalPaidAmount)
          });
        }
      });
    }
    return totalPaidAmount;
  };
  closeAlertModalCallBack = (isOpen) => {
    this.setState({
      isShowArPopup: isOpen,
      isShowCreditMemoPopup: isOpen,
      moduleForPopup: [],
    });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowSalesModule: isOpen, //Added line
      isShowPickTicketModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowARModule: isOpen,
      isShowCreditMemoModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPickTicketModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPickTicketModule: true,
          moduleForPopup: (
            <PopupPickTicketModule
              pickTicketCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPaidAmount = (e, value, invoice) => {
    if (e.detail === 1) {
      if (value != 0) {
        this.setState({ isShowInvoiceAppliedCMAmountPopup: true });
        let readrestInput = new RestReadRequest();
        readrestInput.companyCode = this.companyCode;
        readrestInput.code = invoice;
        //  if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
        AccountReceivableService.readAccountReceivablePaymentLinesForInvoice(
          readrestInput,
          this.readAccountReceivablePageResponse,
          this.errorCallBack
        );
        // } else {
        //   this.inValidAccess(1);
        // }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  readAccountReceivablePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.accountReceivablePaymentDetailPageList != null
    ) {
      let readARAppliedList = [];
      if (
        !isEmptyArray(
          response.data.accountReceivablePaymentDetailPageList
            .accountReceivablePaymentDetails
        )
      ) {
        readARAppliedList =
          response.data.accountReceivablePaymentDetailPageList
            .accountReceivablePaymentDetails;
        if (readARAppliedList != null) {
          let readArList = [];
          for (let list of readARAppliedList) {
            if (list.paymentType == 1) {
              list.paymentType = "CHECK";
            } else if (list.paymentType == 2) {
              list.paymentType = "CREDIT_MEMO";
            } else if (list.paymentType == 3) {
              list.paymentType = "CREDIT_CARD";
            } else if (list.paymentType == 4) {
              list.paymentType = "DEBIT_CARD";
            } else if (list.paymentType == 5) {
              list.paymentType = "CASH";
            } else if (list.paymentType == 6) {
              list.paymentType = "CHARGE_BACK";
            } else if (list.paymentType == 8) {
              list.paymentType = "WIRE_TRANSFER";
            } else if (list.paymentType == 9) {
              list.paymentType = "ACH";
            }
            readArList.push(list);
          }
          readARAppliedList = readArList;
        }
      }
      this.setState({
        readARAppliedList: readARAppliedList,
        isShowArPopup: true,
      });
    }
  };
  viewCreditMemoAmount = (e, value, invoice) => {
    if (e.detail === 1) {
      if (value != 0) {
        let readrestInput = new RestReadRequest();
        readrestInput.companyCode = this.companyCode;
        readrestInput.code = invoice;
        //  if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
        AccountReceivableService.readAccountReceivablePaymentLinesForInvoice(
          readrestInput,
          this.readCreditMemoPageResponse,
          this.errorCallBack
        );
        // } else {
        //   this.inValidAccess(1);
        // }
      } else {
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  readCreditMemoPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.accountReceivablePaymentDetailPageList != null
    ) {
      let readCMAppliedList = [];
      if (
        !isEmptyArray(
          response.data.accountReceivablePaymentDetailPageList
            .accountReceivablePaymentDetails
        )
      ) {
        readCMAppliedList =
          response.data.accountReceivablePaymentDetailPageList
            .accountReceivablePaymentDetails;
        if (readCMAppliedList != null) {
          let readArList = [];
          for (let list of readCMAppliedList) {
            if (list.paymentType == 1) {
              list.paymentType = "CHECK";
            } else if (list.paymentType == 2) {
              list.paymentType = "CREDIT_MEMO";
            } else if (list.paymentType == 3) {
              list.paymentType = "CREDIT_CARD";
            } else if (list.paymentType == 4) {
              list.paymentType = "DEBIT_CARD";
            } else if (list.paymentType == 5) {
              list.paymentType = "CASH";
            } else if (list.paymentType == 6) {
              list.paymentType = "CHARGE_BACK";
            } else if (list.paymentType == 8) {
              list.paymentType = "WIRE_TRANSFER";
            } else if (list.paymentType == 9) {
              list.paymentType = "ACH";
            }
            readArList.push(list);
          }
          readCMAppliedList = readArList;
        }
      }
      this.setState({
        readCMAppliedList: readCMAppliedList,
        isShowCreditMemoPopup: true,
      });
    }
  };
  viewARModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowARModule: true,
          moduleForPopup: (
            <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  viewCreditMemoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCreditMemoModule: true,
          moduleForPopup: (
            <PopupCreditMemoModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      // this.setState({
      //   isShowProgressBarPopup: true,
      //   progressLoadingText: "Sorting ...",
      // });
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";

      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inquiryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inquiryDataList: sorted });
    }
    // this.setState({
    //   isShowProgressBarPopup: false,
    //   progressLoadingText: "",
    // });
  };
  handleSortingAppliedAmountChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingAppliedAmount(sortField, sortOrder);
    }
  };
  handleSortingAppliedAmount = (sortField, sortOrder) => {
    let list = this.state.readARAppliedList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ readARAppliedList: sorted });
    }
  };

  handleSortingCMAppliedAmountChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingCMAppliedAmount(sortField, sortOrder);
    }
  };
  handleSortingCMAppliedAmount = (sortField, sortOrder) => {
    let list = this.state.readCMAppliedList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ readCMAppliedList: sorted });
    }
  };

  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          showHideSecondHeader={this.showHideSecondHeader}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          salesPersonCodeOnChange={this.salesPersonCodeOnChange}
          salesPersonOnChange={this.salesPersonOnChange}
          addSalesPerson={this.addSalesPerson}
          deleteSalesPerson={this.deleteSalesPerson}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          salesPersonEnterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
          salesPersonCodeEnterKeyEventHandler={
            this.salesPersonCodeEnterKeyEventHandler
          }
          displayAutoCompleteSalesPersonCodeList={
            this.displayAutoCompleteSalesPersonCodeList
          }
          displayAutoCompleteSalesPersonList={
            this.displayAutoCompleteSalesPersonList
          }
          onCityChange={this.onCityChange}
          cityEnterKeyEvent={this.cityEnterKeyEvent}
          displayAutoCompleteCityList={this.displayAutoCompleteCityList}
        />
        {this.state.isInquiryDatasFound && (
          <div className="div_default">
            <Table id="fabrics_tables">
              <thead>
                <tr>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "salesOrderNumber")
                    }
                  >
                    Order#
                    {this.state.order === "desc" &&
                    this.state.sortField === "salesOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "customerPurchaseOrderNumber")
                    }
                  >
                    CustomerPO#
                    {this.state.order === "desc" &&
                    this.state.sortField === "customerPurchaseOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "orderStartDate")
                    }
                  >
                    Order StartDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "orderStartDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "orderStopDate")
                    }
                  >
                    Order StopDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "orderStopDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "salesPerson")}
                  >
                    SalesPerson
                    {this.state.order === "desc" &&
                    this.state.sortField === "salesPerson" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "cityCode")}>
                    City
                    {this.state.order === "desc" &&
                    this.state.sortField === "cityCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "orderTotalQuantity")
                    }
                  >
                    OrderTotalQty
                    {this.state.order === "desc" &&
                    this.state.sortField === "orderTotalQuantity" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "salesOrderStatus")
                    }
                  >
                    SO Status
                    {this.state.order === "desc" &&
                    this.state.sortField === "salesOrderStatus" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "grandTotalAmount")
                    }
                  >
                    Amount
                    {this.state.order === "desc" &&
                    this.state.sortField === "grandTotalAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th>PickTicket# </th>
                  <th>Date</th>
                  <th>PT Status</th>
                  <th>Invoice#</th>
                  <th>Inv Date</th>
                  <th>Inv Amount</th>
                  <th>Inv Status</th>
                  <th>Total Paid </th>
                  <th>Total Cred</th>
                  <th>Total Due</th>
                </tr>
              </thead>
              <tbody>
                {inquiryDataList.map((inquiryInfo, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewSalesModule(e, inquiryInfo.salesOrderNumber)
                        }
                      >
                        {inquiryInfo.salesOrderNumber}
                      </Button>
                    </td>
                    <td>{inquiryInfo.customerPurchaseOrderNumber}</td>
                    <td>{inquiryInfo.orderStartDate}</td>
                    <td>{inquiryInfo.orderStopDate}</td>
                    <td>{inquiryInfo.salesPerson}</td>
                    <td>{inquiryInfo.cityCode}</td>
                    <td className="text-right">
                      {toCommaSeperatedAmount(inquiryInfo.orderTotalQuantity)}
                    </td>
                    <td>
                      {ModuleUtils.getSalesOrderStatusCaption(
                        inquiryInfo.salesOrderStatus
                      )}
                    </td>
                    <td className="text-right">
                      {toCommaSeperatedAmount(inquiryInfo.grandTotalAmount)}
                    </td>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewPickTicketModule(
                            e,
                            this.pickticket(inquiryInfo.pickTicketInfos)
                          )
                        }
                      >
                        {this.pickticket(inquiryInfo.pickTicketInfos)}
                      </Button>
                    </td>
                    <td>{this.date(inquiryInfo.pickTicketInfos)}</td>
                    <td>{this.status(inquiryInfo.pickTicketInfos)}</td>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewInvoiceModule(
                            e,
                            this.invoice(inquiryInfo.pickTicketInfos)
                          )
                        }
                      >
                        {this.invoice(inquiryInfo.pickTicketInfos)}
                      </Button>
                    </td>
                    <td>{this.invoiceDate(inquiryInfo.pickTicketInfos)}</td>
                    <td className="text-right">{this.amount(inquiryInfo.pickTicketInfos)}</td>
                    <td>{this.invoiceStatus(inquiryInfo.pickTicketInfos)}</td>
                    <td className="text-right">
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewPaidAmount(
                            e,
                            this.totalPaidAmount(inquiryInfo.pickTicketInfos),
                            this.invoice(inquiryInfo.pickTicketInfos)
                          )
                        }
                      >
                        {this.totalPaidAmount(inquiryInfo.pickTicketInfos)}
                        
                      </Button>
                    </td>
                    <td className="text-right">
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewCreditMemoAmount(
                            e,
                            this.totalCreditAmount(inquiryInfo.pickTicketInfos),
                            this.invoice(inquiryInfo.pickTicketInfos)
                          )
                        }
                      >
                        {this.totalCreditAmount(inquiryInfo.pickTicketInfos)}
                      </Button>
                    </td>
                    <td className="text-right">{this.totalDueAmount(inquiryInfo.pickTicketInfos)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {inquiryDataList.length != 0 ? null : (
              <div className="no_Data">{"NO DATA"}</div>
            )}
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPickTicketModule}
          popupLvlClass={"popupSizeLevel1"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowArPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Invoice Posted Applied Payment Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              <Row>
                <FormLabel> Details </FormLabel>
              </Row>
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingAppliedAmountChange(
                          e,
                          "accountReceivableNumber"
                        )
                      }
                    >
                      AR#
                      {this.state.order === "desc" &&
                      this.state.sortField === "accountReceivableNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingAppliedAmountChange(
                          e,
                          "paymentPostDate"
                        )
                      }
                    >
                      Date
                      {this.state.order === "desc" &&
                      this.state.sortField === "paymentPostDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingAppliedAmountChange(e, "paymentType")
                      }
                    >
                      Type
                      {this.state.order === "desc" &&
                      this.state.sortField === "paymentType" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingAppliedAmountChange(
                          e,
                          "documentNumber"
                        )
                      }
                    >
                      Document#
                      {this.state.order === "desc" &&
                      this.state.sortField === "documentNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingAppliedAmountChange(
                          e,
                          "paymentAmount"
                        )
                      }
                    >
                      AppliedAmount
                      {this.state.order === "desc" &&
                      this.state.sortField === "paymentAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingAppliedAmountChange(e, "currencyCode")
                      }
                    >
                      Currency
                      {this.state.order === "desc" &&
                      this.state.sortField === "currencyCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingAppliedAmountChange(e, "status")
                      }
                    >
                      Status
                      {this.state.order === "desc" &&
                      this.state.sortField === "status" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                  </tr>
                </thead>
                {this.state.readARAppliedList != null && (
                  <tbody>
                    {this.state.readARAppliedList.map((list, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewARModule(e, list.accountReceivableNumber)
                            }
                          >
                            {list.accountReceivableNumber}
                          </Button>
                        </td>
                        <td>{list.paymentPostDate}</td>
                        <td>{list.paymentType}</td>
                        <td>{list.documentNumber}</td>
                        <td className="text-right">{toCommaSeperatedAmount(list.paymentAmount)} </td>
                        <td>{list.currencyCode}</td>
                        <td>{list.status}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowCreditMemoPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Invoice Posted CreditMemo Payment Details "}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="sales_line_pop">
              <Row>
                <FormLabel> Details </FormLabel>
              </Row>
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingCMAppliedAmountChange(
                          e,
                          "accountReceivableNumber"
                        )
                      }
                    >
                      AR#
                      {this.state.order === "desc" &&
                      this.state.sortField === "accountReceivableNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCMAppliedAmountChange(
                          e,
                          "paymentPostDate"
                        )
                      }
                    >
                      Date
                      {this.state.order === "desc" &&
                      this.state.sortField === "paymentPostDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCMAppliedAmountChange(
                          e,
                          "paymentType"
                        )
                      }
                    >
                      Type
                      {this.state.order === "desc" &&
                      this.state.sortField === "paymentType" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCMAppliedAmountChange(
                          e,
                          "documentNumber"
                        )
                      }
                    >
                      CreditMemo#
                      {this.state.order === "desc" &&
                      this.state.sortField === "documentNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCMAppliedAmountChange(
                          e,
                          "paymentAmount"
                        )
                      }
                    >
                      AppliedAmount
                      {this.state.order === "desc" &&
                      this.state.sortField === "paymentAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCMAppliedAmountChange(
                          e,
                          "currencyCode"
                        )
                      }
                    >
                      Currency
                      {this.state.order === "desc" &&
                      this.state.sortField === "currencyCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCMAppliedAmountChange(e, "status")
                      }
                    >
                      Status
                      {this.state.order === "desc" &&
                      this.state.sortField === "status" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                  </tr>
                </thead>
                {this.state.readCMAppliedList != null && (
                  <tbody>
                    {this.state.readCMAppliedList.map((list, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewARModule(e, list.accountReceivableNumber)
                            }
                          >
                            {list.accountReceivableNumber}
                          </Button>
                        </td>
                        <td>{list.paymentPostDate}</td>
                        <td>{list.paymentType}</td>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewCreditMemoModule(
                                e,
                                list.documentNumber,
                                list
                              )
                            }
                          >
                            {list.documentNumber}
                          </Button>
                        </td>
                        <td className="text-right">{toCommaSeperatedAmount(list.paymentAmount)}</td>
                        <td>{list.currencyCode}</td>
                        <td>{list.status}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
            </div>
          }
        />
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      criteria: this.props.criteria,
      customerList: this.props.customerList,
      isCollapsible_open: this.props.isCollapsible_open,
    };
    this.customerCodeRef = React.createRef();
    this.salesPersonCodeRef = React.createRef();
    this.salesPersonRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;

    this.initLookupHandlers();
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.customerCodeRef.current != null) {
      this.customerCodeRef.current.focus();
    }
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });

    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.props.salesPersons,
      "SalesPerson"
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.props.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
  };
  deleteSalesPerson = (e,val, rowData) => {
    this.props.deleteSalesPerson(rowData);
  };

  salesPersonColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
        "SalesPerson",
          "code",
          true
        )
        .setStyleDetails("left")   
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
        "Name",
          "description",
          true
        )
        .setStyleDetails("left")   
    );
   
    columns.push(
      new ColumnDefinition()
      .setDetails("", <DeleteIcon />, false)
      .setClickDetails(false, true, this.deleteSalesPerson, <DeleteIcon />)
    );
  
    return columns;
  };


  // salesPersonColumnDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("SalesPerson#", "code", 0, true)
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Name", "description")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails(
  //         "Remove",
  //         <DeleteIcon />,
  //         // true,
  //         1,
  //         false,
  //         null,
  //         false,
  //         null, //image link call back
  //         "1em", //min-width
  //         "20%", //max-width
  //         false,
  //         null,
  //         false
  //       )
  //       .setEditableDetails(
  //         false,
  //         "",
  //         null,
  //         true,
  //         this.deleteSalesPerson,
  //         false,
  //         null
  //       )
  //   );
  //   return columnList;
  // };
  addSalesPerson = (e) => {
    if (e.detail === 1) {
      this.props.addSalesPerson();
      if (this.salesPersonCodeRef != null) {
        this.salesPersonCodeRef.current.clear();
        this.salesPersonCodeRef.current.focus();
      }
    }
  };
  customerCodeOnChange = (e) => {
    this.props.customerCodeOnChange(e);
  };
  salesPersonCodeOnChange = (e) => {
    this.props.salesPersonCodeOnChange(e);
  };
  salesPersonOnChange = (e) => {
    this.props.salesPersonOnChange(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onCityChange = (e) => {
    this.props.onCityChange(e);
  };
  cityEnterKeyEvent = (e) => {
    this.props.cityEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = (e) => {
    this.props.displayAutoCompleteCityList(e);
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) this.props.showHideSecondHeader();
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteList = () => {
    this.props.displayAutoCompleteList();
  };
  salesPersonEnterKeyEventHandler = (e) => {
    this.props.salesPersonEnterKeyEventHandler(e);
  };
  salesPersonCodeEnterKeyEventHandler = (e) => {
    this.props.salesPersonCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteSalesPersonList = () => {
    this.props.displayAutoCompleteSalesPersonList();
  };
  displayAutoCompleteSalesPersonCodeList = () => {
    this.props.displayAutoCompleteSalesPersonCodeList();
  };
  render() {
    let criteria = this.props.criteria;
    let salesPersonDatas = this.props.salesPersonDatas;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.customerCodeRef}
              name="customerCode"
              onChange={this.customerCodeOnChange}
              value={criteria.customerCode}
              lookupRequired={true}
              lookupHandler={this.state.customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.customerPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteList}
              showAutoCompleteList={this.props.showAutoCompleteCustomerList}
              disabled={isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="customerName"
              onChange={this.onChange}
              value={criteria.customerName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>SalesPerson</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.salesPersonRef}
              name="salesPersonCode"
              onChange={this.salesPersonCodeOnChange}
              value={criteria.salesPersonCode}
              lookupRequired={true}
              lookupHandler={this.state.salesPersonLookupHandler}
              enterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
              autoCompleteListData={
                this.props.salesPersonPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteSalesPersonList}
              showAutoCompleteList={this.props.showAutoCompleteSalesPersonList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              name="salesPersonName"
              onChange={this.onChange}
              value={criteria.salesPersonName}
              disabled={true}
            />
          </Col>
          <Col>
            <CollapseComponent
              isOpen={this.props.isCollapsible_open}
              onClick={(e) => this.showHideSecondHeader(e)}
            />
          </Col>
        </Row>
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>From OrderDate</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="fromOrderDate"
                onChange={this.onChange}
                value={criteria.fromOrderDate}
                disabled={isDisableFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>To OrderDate</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="toOrderDate"
                onChange={this.onChange}
                value={criteria.toOrderDate}
                disabled={isDisableFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Customer PO#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="customerPurchaseOrderNumber"
                onChange={this.onChange}
                value={criteria.customerPurchaseOrderNumber}
                disabled={isDisableFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>City</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="cityCode"
                onChange={this.onCityChange}
                value={criteria.cityCode}
                lookupRequired={true}
                lookupHandler={this.state.cityLookupHandler}
                enterKeyEventHandler={this.cityEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
                disabled={isDisableFields}
              />
            </Col>
          </Row>
        )}
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="1">
              <FormLabel>SalesPerson</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.salesPersonCodeRef}
                name="salesPersonCode"
                onChange={this.salesPersonOnChange}
                value={criteria.salesPersonCode}
                lookupRequired={true}
                lookupHandler={this.state.salesPersonLookupHandler}
                enterKeyEventHandler={this.salesPersonCodeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.salesPersonCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteSalesPersonCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteSalesPersonCodeList
                }
                disabled={isDisableFields}
              />
            </Col>
            <Col sm="1">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addSalesPerson(e)}
                disabled={isDisableFields}
              >
                Add
              </Button>
            </Col>
          </Row>
        )}
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="4">
            

              <CustomTable
data={salesPersonDatas}
columns={this.salesPersonColumnDefinitions()}
label={"SalesPerson Data List"}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

function CustomerServiceInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CustomerServiceInq {...props} name="" /> <br />
    </div>
  );
}

export default CustomerServiceInquiry;
